module.exports = __webpack_public_path__ + "assets/img/33_254_big.e15462cb.jpg";